import { render, staticRenderFns } from "./Fondi.vue?vue&type=template&id=6b78db8c&scoped=true&"
import script from "./Fondi.vue?vue&type=script&lang=js&"
export * from "./Fondi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b78db8c",
  null
  
)

export default component.exports